var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_2696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3332 8.02236C13.3066 6.70379 15.6266 6 18 6C21.1826 6 24.2348 7.26428 26.4853 9.51472C28.7357 11.7652 30 14.8174 30 18C30 20.3734 29.2962 22.6935 27.9776 24.6668C26.6591 26.6402 24.7849 28.1783 22.5922 29.0866C20.3995 29.9948 17.9867 30.2324 15.6589 29.7694C13.3312 29.3064 11.193 28.1635 9.51472 26.4853C7.83649 24.8071 6.6936 22.6689 6.23058 20.3411C5.76756 18.0133 6.0052 15.6005 6.91345 13.4078C7.8217 11.2151 9.35977 9.34094 11.3332 8.02236ZM22.0191 13.9809C21.702 13.6638 21.1879 13.6638 20.8708 13.9809L18 16.8517L15.1292 13.9809C14.8121 13.6638 14.298 13.6638 13.9809 13.9809C13.6638 14.298 13.6638 14.8121 13.9809 15.1292L16.8517 18L13.9809 20.8708C13.6638 21.1879 13.6638 21.702 13.9809 22.0191C14.298 22.3362 14.8121 22.3362 15.1292 22.0191L18 19.1483L20.8708 22.0191C21.1879 22.3362 21.702 22.3362 22.0191 22.0191C22.3362 21.702 22.3362 21.1879 22.0191 20.8708L19.1483 18L22.0191 15.1292C22.3362 14.8121 22.3362 14.298 22.0191 13.9809Z",
    fill: "#FF1616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_2696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d00ff5021a62dc619ab24bd0921be796.svg";
export { ForwardRef as ReactComponent };